module.exports = __webpack_public_path__ + "img/c733bc6.jpg";